import { OnboardingLocation } from '../models/Onboarding/OnboardingLocation'
import { ApprovalTypes } from './constants'

export const formatAddress = (location: OnboardingLocation) => {
  return [
    location.address,
    `${location.city}, ${location.state} ${location.zipCode}`,
  ]
}

export const formatApprovalType = (approvalType: string | null): string => {
  switch (approvalType) {
    case ApprovalTypes.Auto:
      return 'Auto Approval'
    case ApprovalTypes.Manual:
      return 'Manual Approval'
    default:
      return ''
  }
}

export const formatCurrency = (amount: number): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount)

export function formatNumber(value: number): string {
  if (value == null) {
    return ''
  }

  if (Number.isInteger(value)) {
    return value.toString()
  }
  return value.toFixed(2)
}

export function getAllLocationsDurationLabel(numberOfDays: number): string {
  switch (numberOfDays) {
    case 7: return '1 week'
    case 14: return '2 weeks'
    case 30: return '1 month'
    case 90: return '3 months'
    default: return `${numberOfDays} days`
  }
}

export function getAllLocationsDurationLabelVerbose(numberOfDays: number): string {
  switch (numberOfDays) {
    case 7: return '7 days (1 week)'
    case 14: return '14 days (2 weeks)'
    case 30: return '30 days (1 month)'
    case 90: return '90 days (3 months)'
    default: return `${numberOfDays} days`
  }
}
